import { getGridMeta } from '@/service/meta-service';
export default {
    state() {
        return {
            regGrid: [],
        };
    },
    mutations: {
        setGridMetaData(state, data) {
            state.regGrid = [...data];
        },
    },
    actions: {
        async loadGridMetaData({ commit }, payload) {
            const response = await getGridMeta(`meta./${payload.api}/meta/get`, payload.name);
            if (response.result) {
                commit('setGridMetaData', response.meta_data);
            }
        },
        cleanGridMetaData({ commit }) {
            commit('setGridMetaData', []);
        },
    },
};
